module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.$t('integration.label')
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--sm btn--info btn--outline",
    class: {
      'is-active': !_vm.level
    },
    on: {
      "click": function($event) {
        _vm.level = null
      }
    }
  }, [_vm._v("\n      Todos\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--sm btn--danger btn--outline",
    class: {
      'is-active': _vm.level
    },
    on: {
      "click": function($event) {
        _vm.level = 'critical'
      }
    }
  }, [_vm._v("\n      Erros\n    ")])]), _vm._v(" "), (_vm.logsTotal > 0) ? _c('ul', {
    staticClass: "c-stream"
  }, _vm._l((_vm.logs), function(log) {
    return _c('li', {
      key: log,
      staticClass: "c-stream__item"
    }, [_c('span', {
      staticClass: "c-stream__badge hint",
      class: log.level,
      attrs: {
        "data-label": _vm.$t(("level." + (log.level) + ".label"))
      }
    }), _vm._v(" "), _c('time', {
      staticClass: "u-text-muted u-fs-12"
    }, [_vm._v(_vm._s(_vm._f("moment")(log.updated, 'from')))]), _vm._v(" "), _c('div', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.showModal(log)
        }
      }
    }, [_vm._v("\n        " + _vm._s(log.message) + "\n      ")])])
  }), 0) : _c('div', {
    staticClass: "u-textCenter"
  }, [_vm._v("\n    Nenhum registro encontrado.\n  ")]), _vm._v(" "), (_vm.modalLog) ? _c('log-modal', {
    attrs: {
      "log": _vm.modalLog
    },
    model: {
      value: (_vm.showModalFlag),
      callback: function($$v) {
        _vm.showModalFlag = $$v
      },
      expression: "showModalFlag"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-290ea0e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SimpleListLog.vue
// module id = 3004
// module chunks = 0